export const GRECAPTCHA_WIDGET_ID = 'g-recaptcha-widget'
export const GRECAPTCHA_SCRIPT_ID = 'GRecaptcha'

let widgetId: number | null = null
let pendingScriptLoads: Array<() => void> = []
let callbackConsumed = false

function resetWidget () {
  callbackConsumed = false
  const grecaptcha = (window as any).grecaptcha
  const container = document.getElementById(GRECAPTCHA_WIDGET_ID)

  if (grecaptcha && widgetId !== null) {
    try {
      grecaptcha.reset(widgetId)
    } catch {
      // widget already removed from DOM
    }
  }

  widgetId = null

  if (container) {
    container.innerHTML = ''
  }
}

function loadRecaptchaScript (onLoad: () => void, errorCb: (hasError: boolean) => void) {
  if ((window as any).grecaptcha) {
    onLoad()
    return
  }

  const existingScript = document.getElementById(GRECAPTCHA_SCRIPT_ID)

  if (existingScript?.getAttribute('data-recaptcha-loaded') === 'true') {
    if ((window as any).grecaptcha) {
      onLoad()
    } else {
      existingScript.remove()
      loadRecaptchaScript(onLoad, errorCb)
    }
    return
  }

  if (existingScript) {
    pendingScriptLoads.push(onLoad)
    return
  }

  pendingScriptLoads = [onLoad]

  const script = document.createElement('script')
  script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=pt-BR'
  script.id = GRECAPTCHA_SCRIPT_ID
  script.async = true
  script.defer = true
  script.setAttribute('data-testid', GRECAPTCHA_SCRIPT_ID)
  script.onload = () => {
    script.setAttribute('data-recaptcha-loaded', 'true')
    const callbacks = [...pendingScriptLoads]
    pendingScriptLoads = []
    callbacks.forEach((callback) => callback())
  }
  script.onerror = () => {
    pendingScriptLoads = []
    errorCb(true)
  }
  document.body.appendChild(script)
}
const mountRecaptchaWidget = (
  sitekey: string,
  callback: (token: string) => void,
  errorCb: (hasError: boolean) => void
) => {
  if (!sitekey) {
    errorCb(true)
    return
  }

  const render = () => {
    const grecaptcha = (window as any).grecaptcha

    if (!grecaptcha) {
      errorCb(true)
      return
    }

    grecaptcha.ready(() => {
      window.requestAnimationFrame(() => {
        const container = document.getElementById(GRECAPTCHA_WIDGET_ID)

        if (!container) {
          errorCb(true)
          return
        }

        resetWidget()

        try {
          widgetId = grecaptcha.render(container, {
            sitekey,
            callback: () => {
              if (callbackConsumed) return

              const responseToken = String(grecaptcha.getResponse() || '').trim()
              if (!responseToken) return

              callbackConsumed = true
              callback(responseToken)
            },
            'error-callback': () => errorCb(true),
            'expired-callback': () => {
              if (widgetId !== null) {
                grecaptcha.reset(widgetId)
              }
            }
          })
        } catch {
          errorCb(true)
        }
      })
    })
  }

  loadRecaptchaScript(render, errorCb)
}

const unmountRecaptcha = () => {
  resetWidget()
  pendingScriptLoads = []
  document.getElementById(GRECAPTCHA_SCRIPT_ID)?.remove()
}

export default mountRecaptchaWidget
export { mountRecaptchaWidget, unmountRecaptcha }
